<script>
import Vue from 'vue'
import numeral from 'numeral'

export default Vue.extend({
    name: 'DecimalCellRenderer',
    methods: {
        getValue () {
            const { value } = this.params
            return value
        },
    },
    render (h) {
        const { value } = this.params
        const outputValue = ![undefined, null].includes(value) ? numeral(value).format(`0.00`) : ''
        return h(
            'div',
            {
                class: 'DecimalCellRenderer',
            },
            [
                h('span', {}, outputValue),
            ],
        )
    },
})
</script>
